import { createContext } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { noop } from "@common/helpers/function";
import { FinancialDocumentFilters } from "../FinancialDocumentsPageFilters/lib";

export interface FinancialDocumentBulkSelectionContextValue {
    selectedCount: number;
    selected: FinancialDocumentListItem[];
    totalCount: number;
    hasSelectedByCurrentFilters: boolean;
    filtersSelection: FinancialDocumentFilters | null;
    select(
        financialDocumentOrDocuments:
            | FinancialDocumentListItem
            | FinancialDocumentListItem[],
    ): void;
    deselect(
        financialDocumentOrDocuments:
            | FinancialDocumentListItem
            | FinancialDocumentListItem[],
    ): void;
    isSelected(financialDocument: FinancialDocumentListItem): boolean;
    clearSelection(): void;
    selectAll(): void;
}

export const financialDocumentBulkSelectionContext =
    createContext<FinancialDocumentBulkSelectionContextValue>({
        selected: [],
        selectedCount: 0,
        totalCount: 0,
        hasSelectedByCurrentFilters: false,
        select: noop,
        deselect: noop,
        isSelected: () => false,
        selectAll: noop,
        clearSelection: noop,
        filtersSelection: null,
    });
